module.exports = __webpack_public_path__ + "img/heart_mild.05a1478b.png";